'use client';
import React, { useEffect, useRef, useState } from 'react';
import {
	ChevronRight,
	ChevronsRight,
	ChevronLeft,
	ChevronsLeft,
} from 'react-feather';

import classes from './BuyPaginationBar.module.css';

const PaginationBar = ({ paginationData, onPageChange, loading }) => {
	const { currentPage, totalPages } = paginationData;
	const scrollContainerRef = useRef(null);

	const [innerWidth, setInnerWidth] = useState();
	useEffect(() => {
		setInnerWidth(window.innerWidth);
	}, []);

	const goToPage = (page) => {
		if (page >= 1 && page <= totalPages) {
			onPageChange(page);
		}
	};

	useEffect(() => {
		const scrollContainer = scrollContainerRef.current;
		const activeButton = scrollContainer?.querySelector(
			`.${classes.activePage}`
		);
		if (activeButton) {
			const activeButtonOffset = activeButton.offsetLeft;
			const containerWidth = scrollContainer.clientWidth;
			const scrollLeft =
				activeButtonOffset - containerWidth / 2 + activeButton.clientWidth / 2;

			scrollContainer.scrollLeft = scrollLeft;
		}
	}, [currentPage, totalPages]);

	const renderPageButtons = () => {
		const pageButtons = [];
		const numPagesToShow = innerWidth < 600 ? 3 : 7; // Conditionally set the number of pages
		const halfPagesToShow = Math.floor(numPagesToShow / 2);

		let startPage = Math.max(currentPage - halfPagesToShow, 1);
		let endPage = startPage + numPagesToShow - 1;

		if (endPage > totalPages) {
			endPage = totalPages;
			startPage = Math.max(totalPages - numPagesToShow + 1, 1);
		}

		for (let i = startPage; i <= endPage; i++) {
			pageButtons.push(
				<li
					key={i}
					className={`${classes.paginationButton} ${
						currentPage == i ? classes.activePage : ''
					}`}
					onClick={() => goToPage(i)}
					disabled={loading}
				>
					{i}
				</li>
			);
		}

		return pageButtons;
	};

	return (
		<ul className={classes.paginationContainer} ref={scrollContainerRef}>
			{currentPage > 1 && (
				<li
					className={classes.paginationButton1}
					key="first"
					onClick={() => goToPage(1)}
					disabled={loading}
				>
					<ChevronsLeft size={15} />
				</li>
			)}
			{currentPage > 1 && (
				<li
					key="prev"
					className={classes.paginationButton1}
					onClick={() => goToPage(currentPage - 1)}
					disabled={loading}
				>
					<ChevronLeft size={15} />
				</li>
			)}
			<ul className={classes.renderPageButtons}>{renderPageButtons()}</ul>
			{currentPage < totalPages && (
				<li
					key="next"
					className={classes.paginationButton1}
					onClick={() => goToPage(parseInt(currentPage) + 1)}
					disabled={loading}
				>
					<ChevronRight size={15} />
				</li>
			)}
			{currentPage < totalPages && (
				<li
					key="last"
					className={classes.paginationButton1}
					onClick={() => goToPage(totalPages)}
					disabled={loading}
				>
					<ChevronsRight size={15} />
				</li>
			)}
		</ul>
	);
};

export default PaginationBar;
